if (!window.Eurus.loadedScript.includes('variant-select.js')) {
  window.Eurus.loadedScript.push('variant-select.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xVariantSelect', (
        sectionId,
        unavailableText,
        variantUnavailableText,
        productUrl,
        productId
      ) => ({
        variants: null,
        currentVariant: {},
        options: [],
        cachedResults: [],
        init() {
          this.variants = xParseJSON(this.$el.getAttribute('x-variants-data'));
  
          document.addEventListener('eurus:cart:items-changed', () => {
            this.cachedResults = [];
            Alpine.store('xUpdateVariantQuanity').updateQuantity(sectionId, productUrl, this.currentVariant.id);
          });
        },
        initMedia(inputType) {
          this.updateOptions(inputType);
          this.updateMasterId();
          this.updateMedia();
        },
        updateVariantSelector(inputType, productPage) {
          this.updateOptions(inputType);
          this.updateMasterId();
          this.updateVariantStatuses(inputType);
  
          if (!this.currentVariant) {
            this.setUnavailable();
            return;
          }
  
          if (productPage) {
            window.history.replaceState({}, '', `?variant=${this.currentVariant.id}`);
          }
  
          this.updateVariantInput();
          this.updateMedia();
          this.updateProductForms();
          this.setAvailable();
          Alpine.store('xPickupAvailable').updatePickUp(sectionId, this.currentVariant.id);
  
          const cacheKey = sectionId + '-' + this.currentVariant.id;
          if (this.cachedResults[cacheKey]) {
            const html = this.cachedResults[cacheKey];
  
            this.renderPriceProduct(html);
            this.renderProductBadges(html);
            this.renderInventoryStatus(html);
            this.renderBuyButtons(html);
            Alpine.store('xUpdateVariantQuanity').render(html, sectionId);
          } else {
            const variantId = this.currentVariant.id;
            fetch(`${productUrl}?variant=${variantId}&section_id=${sectionId}`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                if (variantId == this.currentVariant.id
                  && html.getElementById(`x-product-template-${productId}-${sectionId}`)) {
                  this.renderPriceProduct(html);
                  this.renderProductBadges(html);
                  this.renderInventoryStatus(html);
                  this.renderBuyButtons(html);
                  Alpine.store('xUpdateVariantQuanity').render(html, sectionId);
  
                  this.cachedResults[cacheKey] = html
                }
              });
          }
        },
        updateVariantStatuses(inputType) {
          const variantEl = document.getElementById("variant-update-" + sectionId);
          const selectedOptionOneVariants = this.variants.filter(variant => variantEl.querySelector(':checked').value === variant.option1);
          const inputWrappers = [...variantEl.querySelectorAll('.product-form__input')];
          inputWrappers.forEach((option, index) => {
            if (index === 0) return;
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
            const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
            const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue, inputType)
          });
        },
        setInputAvailability(listOfOptions, listOfAvailableOptions, inputType) {
          if (inputType == "radio") {
            listOfOptions.forEach(input => {
              if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
                input.classList.remove('disabled');
              } else {
                input.classList.add('disabled');
              }
            });
          } else {
            listOfOptions.forEach(input => {
              if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
                input.innerText = input.getAttribute('value');
              } else {
                input.innerText = variantUnavailableText.replace('[value]', input.getAttribute('value'));
              }
            });
          }
        },
        updateOptions(inputType) {
          if (inputType == "radio") {
            const fieldsets = Array.from(this.$refs.element_variant.querySelectorAll('fieldset'));
            this.options = fieldsets.map((fieldset) => {
              return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
            });
          } else {
            this.options = Array.from(this.$refs.element_variant.querySelectorAll('select'), (select) => select.value);
          }
        },
        renderInventoryStatus(html) {
          const destination = document.getElementById('block-inventory-' + sectionId);
          const source = html.getElementById('block-inventory-' + sectionId);
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        updateMedia() {
          if (this.currentVariant.featured_image != null) {
            let slideVariant = document.getElementsByClassName(this.currentVariant.featured_media.id + '-' + sectionId);
            let index = parseInt(slideVariant[0].getAttribute('index'));
  
            let splideEl = document.getElementById("x-product-" + sectionId);
            if (splideEl.splide && this.currentVariant.featured_image != null) {
              splideEl.splide.go(index - 1)
            } else {
              document.addEventListener(`eurus:media-gallery-ready:${sectionId}`, () => {
                splideEl.splide.go(index - 1)
              });
            }
  
            let activeEL = document.getElementById('postion-image-' + sectionId + '-' + this.currentVariant.featured_media.id);
            if (!activeEL) return;
  
            let stackedEL = document.getElementById('stacked-' + sectionId);
            stackedEL.prepend(activeEL);
          }
        },
        updateMasterId() {
          this.currentVariant = this.variants.find((variant) => {
            return !variant.options.map((option, index) => {
              return this.options[index] === option;
            }).includes(false);
          });
        },
        updateVariantInput() {
          const input = document.getElementById("update-variant-" + sectionId);
          if (!input) return;
  
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        },
        updateProductForms() {
          const productForms = document.querySelectorAll(`#product-form-${sectionId}, #product-form-installment-${sectionId}`);
          productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        },
        renderPriceProduct(html) {
          const destination = document.getElementById('price-' + sectionId);
          const source = html.getElementById('price-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        renderProductBadges(html) {
          const destination = document.getElementById('x-badges-' + sectionId);
          const source = html.getElementById('x-badges-'+ sectionId);
          
          if (source && destination) destination.innerHTML += source.innerHTML;
        },
        renderGiftCardRecipient(html) {
          const destination = document.getElementById('gift-card-recipient-' + sectionId);
          const source = html.getElementById('gift-card-recipient-'+ sectionId);
          
          if (source && destination) destination.innerHTML += source.innerHTML;
        },
        renderBuyButtons(html) {
          const atcDestination = document.getElementById('x-atc-button-' + sectionId);
          const atcSource = html.getElementById('x-atc-button-' + sectionId);
          if (atcSource && atcDestination) atcDestination.innerHTML = atcSource.innerHTML;
  
          const paymentButtonDestination = document.getElementById('x-payment-button-' + sectionId);
          const paymentButtonSource = html.getElementById('x-payment-button-' + sectionId);
          if (paymentButtonSource && paymentButtonDestination) {
            if (paymentButtonSource.classList.contains('hidden')) {
              paymentButtonDestination.classList.add('hidden');
            } else {
              paymentButtonDestination.classList.remove('hidden');
            }
          }
  
          if (this.currentVariant.available) {
            /// Enable add to cart button
            if (html.getElementById('form-gift-card-' + sectionId)) {
              document.getElementById('Recipient-checkbox-' + sectionId).checked && atcDestination.disabled ? atcDestination.setAttribute('disabled', 'disabled') : atcDestination.removeAttribute('disabled');
            } else {
              atcDestination.removeAttribute('disabled');
            }
          } else {
            atcDestination.setAttribute('disabled', 'disabled');
          }
        },
        setBuyButtonUnavailable() {
          const productForm = document.getElementById('product-form-' + sectionId);
          if (!productForm) return;
  
          const addButton = productForm.querySelector('#x-atc-button-' + sectionId);
          if (!addButton) return;
  
          addButton.setAttribute('disabled', 'disabled');
          const addButtonText = addButton.querySelector('.x-atc-text');
          addButtonText.textContent = unavailableText;
        },
        setUnavailable() {
          const price = document.getElementById(`price-` + sectionId);
          if (price) price.classList.add('hidden');
  
          const inventory = document.getElementById(`block-inventory-` + sectionId);
          if (inventory) inventory.classList.add('hidden');
  
          const badges = document.getElementById(`x-badges-` + sectionId);
          if (badges) badges.classList.add('hidden');
  
          const pickup = document.getElementById(`pickup-` + sectionId);
          if (pickup) pickup.classList.add('hidden');
  
          const quantity = document.getElementById('x-quantity-' + sectionId);
          if (quantity) quantity.classList.add('unavailable');
  
          this.setBuyButtonUnavailable();
        },
        setAvailable() {
          const price = document.getElementById(`price-` + sectionId);
          if (price) price.classList.remove('hidden');
  
          const inventory = document.getElementById(`block-inventory-` + sectionId);
          if (inventory) inventory.classList.remove('hidden');
  
          const badges = document.getElementById(`x-badges-` + sectionId);
          if (badges) badges.classList.remove('hidden');
  
          const pickup = document.getElementById(`pickup-` + sectionId);
          if (pickup) pickup.classList.remove('hidden');
  
          const quantity = document.getElementById('x-quantity-' + sectionId);
          if (quantity) quantity.classList.remove('unavailable');
        }
      }))
    });
  });

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xPickupAvailable', {
        updatePickUp(id, variantId) {
          const container = document.getElementsByClassName('pick-up-'+ id)[0];
          if (!container) return;
  
          fetch(window.Shopify.routes.root + `variants/${variantId}/?section_id=pickup-availability`)
            .then(response => response.text())
            .then(text => {
              const pickupAvailabilityHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('.shopify-section');
  
              container.innerHTML = pickupAvailabilityHTML.innerHTML;
            })
            .catch(e => {
              console.error(e);
            }); 
        }
      });
    });
  });
  
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xUpdateVariantQuanity', {
        updateQuantity(sectionId, productUrl, currentVariant) {
          const url = currentVariant ? `${productUrl}?variant=${currentVariant}&section_id=${sectionId}` :
                        `${productUrl}?section_id=${sectionId}`;
  
          fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
              let html = new DOMParser().parseFromString(responseText, 'text/html');
              this.render(html, sectionId);
            });
        },
        render(html, sectionId) {
          const destination = document.getElementById('x-quantity-' + sectionId);
          const source = html.getElementById('x-quantity-'+ sectionId);
          if (source && destination) destination.innerHTML = source.innerHTML;
        }
      });
    });
  });
}